import React from 'react'
import PropTypes from 'prop-types'

const AsideInstrument = ({ instruments }) => (
  <div>
    <div className="instruments_title">Instruments: </div>
    {instruments.map((title) => (
      <div key={title} className="instruments_item">
        {title}
      </div>
    ))}
  </div>
)

export default AsideInstrument

AsideInstrument.propTypes = {
  instruments: PropTypes.arrayOf(PropTypes.string),
}
